import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LocationDetail from './LocationDetail';
import action from '../../../../../actions/index';

const mapStateToProps = state => {
    return {
        locationState: state.locationReducer,
        uploadState: state.uploadReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => {
            dispatch(action.uploadAction(filters))
        },
        getLocation: (id) => {
            dispatch(action.getLocation(id))
        },
        setLocation: (location) => dispatch(action.setLocation(location)),
        saveLocation: (params, props) => {
            dispatch(action.saveLocation(params, props))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(LocationDetail));
